export default __webpack_public_path__ + "static/media/white_pawn.ecb9a97c.png";